import React from 'react';

const ML_Linear_Graphs = () => {
    return (
        <div>ML_Linear_Graphs Component</div>
    );
}

export default ML_Linear_Graphs;
